// extracted by mini-css-extract-plugin
export default {"terms":"vAloyHSmjxJK6hqQvLo2","login":"Ff4QE3GrFC9N9Zz8Lu9h","loginText":"eKEPobEIoMbPClFKEbQ5","emailField":"tTN_gGSEvysSzJMUmb17","submitButtonWrapper":"WfJIHsNbsAyDlQCBuHdm"};